import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ParkbewilligungenData, PbActions } from '../parkbewilligungen-data';
import { UserData } from '../../../providers/user-data';

/**
 * Generated class for the PbactionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbactions',
  templateUrl: 'pbactions.html',
})
export class PbactionsPage  implements OnInit {
  public pbActions = PbActions;
  constructor(public navCtrl: NavController
            , public navParams: NavParams
            , public parkbewilligungenData: ParkbewilligungenData
            , private _viewController: ViewController
            , private userData: UserData
    ) 
  {

  }

  ionViewDidLoad() {
    
  }
  ngOnInit(){
    this.parkbewilligungenData.selectedAction = PbActions.None;
  }
  selectAction(action: PbActions){
    this.parkbewilligungenData.selectedAction = action;
    this._viewController.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbactions/pbactions.ts